export const isPercentTextileWasteInRange = (
  value: string | null | undefined
): boolean => {
  if (value === null || value === undefined || value === "") {
    return true;
  }

  const numericValue = Number(value);
  return Number.isFinite(numericValue) && numericValue >= 0 && numericValue <= 100;
};

export const retainPercentTextileWasteInRange = (
  nextValue: string,
  currentValue: string | null | undefined
): string => {
  if (isPercentTextileWasteInRange(nextValue)) {
    return nextValue;
  }

  return isPercentTextileWasteInRange(currentValue) ? currentValue ?? "" : "";
};

export const isFeedstockChipAllowed = (value: string): boolean =>
  /^PC\d{4}-PD\d{4}-RM\d{4}$/i.test(value.trim());

const disallowedPackagingValues = new Set([
  "na",
  "n/a",
  "not available",
  "null",
]);

export const isPackagingForChipAllowed = (value: string): boolean => {
  const normalizedValue = value.trim().toLowerCase();
  return !!normalizedValue && !disallowedPackagingValues.has(normalizedValue);
};
